var map = {
	"./activity.svg": 948704,
	"./add-circle.svg": 865860,
	"./add.svg": 434005,
	"./archive.svg": 771035,
	"./arrow-2.svg": 274651,
	"./arrow-3.svg": 320755,
	"./arrow-down-1.svg": 866065,
	"./arrow-down.svg": 633425,
	"./arrow-expand.svg": 854027,
	"./arrow-left-1.svg": 773280,
	"./arrow-left.svg": 50739,
	"./arrow-right-1.svg": 924238,
	"./arrow-right.svg": 183903,
	"./arrow-up-1.svg": 54333,
	"./arrow-up.svg": 596529,
	"./bag-2.svg": 415690,
	"./book-1.svg": 502852,
	"./book.svg": 880926,
	"./bookmark.svg": 383454,
	"./box-1.svg": 800185,
	"./box.svg": 539324,
	"./brush.svg": 648666,
	"./calendar-tick.svg": 513501,
	"./calendar.svg": 378444,
	"./call.svg": 998093,
	"./camera.svg": 468229,
	"./card.svg": 909411,
	"./chart-2.svg": 54939,
	"./chart.svg": 198366,
	"./clipboard-text.svg": 36306,
	"./clipboard-tick.svg": 838951,
	"./clock-1.svg": 175668,
	"./close-circle.svg": 498902,
	"./code.svg": 102315,
	"./coin.svg": 329005,
	"./color-swatch.svg": 467886,
	"./copy.svg": 477539,
	"./cup.svg": 654378,
	"./custom-alarm.svg": 167069,
	"./custom-archive-thin.svg": 441577,
	"./custom-archive.svg": 184319,
	"./custom-at-sign.svg": 207673,
	"./custom-bell-pin.svg": 752646,
	"./custom-book-check.svg": 57400,
	"./custom-bulletpoints.svg": 449776,
	"./custom-check.svg": 178889,
	"./custom-code.svg": 44825,
	"./custom-collapse.svg": 357571,
	"./custom-color-mode.svg": 777430,
	"./custom-compass.svg": 26906,
	"./custom-credit-card-refresh.svg": 225102,
	"./custom-critical.svg": 307586,
	"./custom-cursor-click.svg": 466115,
	"./custom-distribute-spacing-vertical.svg": 662589,
	"./custom-divider.svg": 364849,
	"./custom-document-play.svg": 470656,
	"./custom-done-all.svg": 759276,
	"./custom-dotpoints.svg": 181816,
	"./custom-dots-tune.svg": 167512,
	"./custom-dots-vertical.svg": 217937,
	"./custom-download.svg": 140112,
	"./custom-expand.svg": 510777,
	"./custom-face-content-plus.svg": 632276,
	"./custom-face-content.svg": 501823,
	"./custom-feather.svg": 687332,
	"./custom-file-search.svg": 919065,
	"./custom-font.svg": 875375,
	"./custom-h1.svg": 275657,
	"./custom-h2.svg": 602976,
	"./custom-h3.svg": 684174,
	"./custom-hashtag.svg": 595621,
	"./custom-home-stars.svg": 657521,
	"./custom-info.svg": 697526,
	"./custom-location.svg": 694942,
	"./custom-minus.svg": 701335,
	"./custom-move-arrow.svg": 860399,
	"./custom-nesting.svg": 512574,
	"./custom-notification-pin.svg": 687462,
	"./custom-numbered-list.svg": 137001,
	"./custom-palette.svg": 154502,
	"./custom-paperclip.svg": 332211,
	"./custom-pause.svg": 854250,
	"./custom-pin.svg": 659325,
	"./custom-public-page.svg": 704671,
	"./custom-puzzle-piece.svg": 215220,
	"./custom-question.svg": 4377,
	"./custom-quote.svg": 252170,
	"./custom-reply.svg": 600196,
	"./custom-rocket.svg": 905098,
	"./custom-save.svg": 726469,
	"./custom-share.svg": 54647,
	"./custom-sparkles.svg": 805936,
	"./custom-stars.svg": 168764,
	"./custom-stepper-shape.svg": 538160,
	"./custom-strikethrough.svg": 255194,
	"./custom-subtasks.svg": 79513,
	"./custom-target.svg": 965476,
	"./custom-text-subscript.svg": 834958,
	"./custom-text-superscript.svg": 114120,
	"./custom-transparent.svg": 392,
	"./custom-unpublished.svg": 741360,
	"./custom-upload.svg": 702890,
	"./custom-user-add.svg": 565008,
	"./custom-user-minus.svg": 989111,
	"./custom-video-check.svg": 186142,
	"./custom-video-file.svg": 22162,
	"./custom-widget-alt.svg": 277675,
	"./custom-x.svg": 934702,
	"./danger.svg": 767090,
	"./diamonds.svg": 515684,
	"./direct-inbox.svg": 617177,
	"./direct-normal.svg": 377577,
	"./direct-send.svg": 234946,
	"./discover.svg": 769547,
	"./dislike.svg": 609158,
	"./document-1.svg": 564240,
	"./document-text.svg": 856829,
	"./edit-2.svg": 943728,
	"./edit.svg": 762952,
	"./element-3-thick.svg": 453746,
	"./element-3.svg": 584923,
	"./element-plus.svg": 143710,
	"./export-2.svg": 870070,
	"./export.svg": 165678,
	"./eye-slash.svg": 430840,
	"./eye.svg": 507351,
	"./filter.svg": 860641,
	"./flag.svg": 843066,
	"./flash-circle.svg": 798001,
	"./flash.svg": 62329,
	"./folder-2.svg": 834791,
	"./folder.svg": 150421,
	"./gallery.svg": 376767,
	"./gift.svg": 516621,
	"./global.svg": 229199,
	"./gps.svg": 55062,
	"./graph.svg": 873810,
	"./grid-8.svg": 608187,
	"./hashtag-1.svg": 215970,
	"./headphone.svg": 685097,
	"./heart.svg": 542718,
	"./home.svg": 814398,
	"./lamp-on.svg": 867682,
	"./layer.svg": 87389,
	"./lifebuoy.svg": 147347,
	"./like.svg": 481854,
	"./link.svg": 832725,
	"./location.svg": 51899,
	"./lock-1.svg": 377230,
	"./login.svg": 833560,
	"./logout.svg": 265578,
	"./magicpen.svg": 374150,
	"./map-1.svg": 459726,
	"./medal-star.svg": 175576,
	"./menu.svg": 908511,
	"./message-text.svg": 437910,
	"./message.svg": 479734,
	"./messages-2.svg": 708981,
	"./messages-3.svg": 184490,
	"./microphone-2.svg": 884884,
	"./minus.svg": 860644,
	"./money.svg": 158523,
	"./moon.svg": 285946,
	"./more.svg": 341045,
	"./music.svg": 889757,
	"./notification.svg": 641337,
	"./numberedList.svg": 644734,
	"./path-2.svg": 625811,
	"./pause.svg": 491939,
	"./people.svg": 793929,
	"./play-circle.svg": 628926,
	"./play.svg": 454977,
	"./profile-2user.svg": 47471,
	"./profile-circle.svg": 356677,
	"./receipt-item.svg": 153063,
	"./record-circle.svg": 663197,
	"./refresh-2.svg": 766375,
	"./repeat.svg": 600794,
	"./rotate-right.svg": 501520,
	"./scan-barcode.svg": 367161,
	"./search-normal-1.svg": 217448,
	"./send-2.svg": 717707,
	"./setting-2.svg": 946107,
	"./setting-tools.svg": 289293,
	"./share.svg": 92256,
	"./shield.svg": 135700,
	"./shop.svg": 823184,
	"./sms.svg": 580726,
	"./sort.svg": 739830,
	"./star-1.svg": 917855,
	"./stop.svg": 446925,
	"./story.svg": 934610,
	"./sun-1.svg": 72758,
	"./tag.svg": 804962,
	"./teacher.svg": 667423,
	"./text-bold.svg": 922769,
	"./text-italic.svg": 607842,
	"./text-link.svg": 820146,
	"./text-strikethrough.svg": 439896,
	"./text-underline.svg": 586494,
	"./text.svg": 659395,
	"./textalign-center.svg": 458221,
	"./textalign-justifycenter.svg": 191111,
	"./textalign-left.svg": 377725,
	"./textalign-right.svg": 141290,
	"./tick-circle.svg": 316140,
	"./ticket-star.svg": 514986,
	"./timer-1.svg": 894084,
	"./trash.svg": 663894,
	"./unlock.svg": 61144,
	"./user-square.svg": 389270,
	"./user.svg": 787390,
	"./verify.svg": 744901,
	"./video-square.svg": 936315,
	"./video.svg": 516244,
	"./videoPlayIcon.svg": 383248,
	"./volume-high.svg": 494097,
	"./wallet.svg": 255721,
	"core/ui/iconsax/linear/activity.svg": 948704,
	"core/ui/iconsax/linear/add-circle.svg": 865860,
	"core/ui/iconsax/linear/add.svg": 434005,
	"core/ui/iconsax/linear/archive.svg": 771035,
	"core/ui/iconsax/linear/arrow-2.svg": 274651,
	"core/ui/iconsax/linear/arrow-3.svg": 320755,
	"core/ui/iconsax/linear/arrow-down-1.svg": 866065,
	"core/ui/iconsax/linear/arrow-down.svg": 633425,
	"core/ui/iconsax/linear/arrow-expand.svg": 854027,
	"core/ui/iconsax/linear/arrow-left-1.svg": 773280,
	"core/ui/iconsax/linear/arrow-left.svg": 50739,
	"core/ui/iconsax/linear/arrow-right-1.svg": 924238,
	"core/ui/iconsax/linear/arrow-right.svg": 183903,
	"core/ui/iconsax/linear/arrow-up-1.svg": 54333,
	"core/ui/iconsax/linear/arrow-up.svg": 596529,
	"core/ui/iconsax/linear/bag-2.svg": 415690,
	"core/ui/iconsax/linear/book-1.svg": 502852,
	"core/ui/iconsax/linear/book.svg": 880926,
	"core/ui/iconsax/linear/bookmark.svg": 383454,
	"core/ui/iconsax/linear/box-1.svg": 800185,
	"core/ui/iconsax/linear/box.svg": 539324,
	"core/ui/iconsax/linear/brush.svg": 648666,
	"core/ui/iconsax/linear/calendar-tick.svg": 513501,
	"core/ui/iconsax/linear/calendar.svg": 378444,
	"core/ui/iconsax/linear/call.svg": 998093,
	"core/ui/iconsax/linear/camera.svg": 468229,
	"core/ui/iconsax/linear/card.svg": 909411,
	"core/ui/iconsax/linear/chart-2.svg": 54939,
	"core/ui/iconsax/linear/chart.svg": 198366,
	"core/ui/iconsax/linear/clipboard-text.svg": 36306,
	"core/ui/iconsax/linear/clipboard-tick.svg": 838951,
	"core/ui/iconsax/linear/clock-1.svg": 175668,
	"core/ui/iconsax/linear/close-circle.svg": 498902,
	"core/ui/iconsax/linear/code.svg": 102315,
	"core/ui/iconsax/linear/coin.svg": 329005,
	"core/ui/iconsax/linear/color-swatch.svg": 467886,
	"core/ui/iconsax/linear/copy.svg": 477539,
	"core/ui/iconsax/linear/cup.svg": 654378,
	"core/ui/iconsax/linear/custom-alarm.svg": 167069,
	"core/ui/iconsax/linear/custom-archive-thin.svg": 441577,
	"core/ui/iconsax/linear/custom-archive.svg": 184319,
	"core/ui/iconsax/linear/custom-at-sign.svg": 207673,
	"core/ui/iconsax/linear/custom-bell-pin.svg": 752646,
	"core/ui/iconsax/linear/custom-book-check.svg": 57400,
	"core/ui/iconsax/linear/custom-bulletpoints.svg": 449776,
	"core/ui/iconsax/linear/custom-check.svg": 178889,
	"core/ui/iconsax/linear/custom-code.svg": 44825,
	"core/ui/iconsax/linear/custom-collapse.svg": 357571,
	"core/ui/iconsax/linear/custom-color-mode.svg": 777430,
	"core/ui/iconsax/linear/custom-compass.svg": 26906,
	"core/ui/iconsax/linear/custom-credit-card-refresh.svg": 225102,
	"core/ui/iconsax/linear/custom-critical.svg": 307586,
	"core/ui/iconsax/linear/custom-cursor-click.svg": 466115,
	"core/ui/iconsax/linear/custom-distribute-spacing-vertical.svg": 662589,
	"core/ui/iconsax/linear/custom-divider.svg": 364849,
	"core/ui/iconsax/linear/custom-document-play.svg": 470656,
	"core/ui/iconsax/linear/custom-done-all.svg": 759276,
	"core/ui/iconsax/linear/custom-dotpoints.svg": 181816,
	"core/ui/iconsax/linear/custom-dots-tune.svg": 167512,
	"core/ui/iconsax/linear/custom-dots-vertical.svg": 217937,
	"core/ui/iconsax/linear/custom-download.svg": 140112,
	"core/ui/iconsax/linear/custom-expand.svg": 510777,
	"core/ui/iconsax/linear/custom-face-content-plus.svg": 632276,
	"core/ui/iconsax/linear/custom-face-content.svg": 501823,
	"core/ui/iconsax/linear/custom-feather.svg": 687332,
	"core/ui/iconsax/linear/custom-file-search.svg": 919065,
	"core/ui/iconsax/linear/custom-font.svg": 875375,
	"core/ui/iconsax/linear/custom-h1.svg": 275657,
	"core/ui/iconsax/linear/custom-h2.svg": 602976,
	"core/ui/iconsax/linear/custom-h3.svg": 684174,
	"core/ui/iconsax/linear/custom-hashtag.svg": 595621,
	"core/ui/iconsax/linear/custom-home-stars.svg": 657521,
	"core/ui/iconsax/linear/custom-info.svg": 697526,
	"core/ui/iconsax/linear/custom-location.svg": 694942,
	"core/ui/iconsax/linear/custom-minus.svg": 701335,
	"core/ui/iconsax/linear/custom-move-arrow.svg": 860399,
	"core/ui/iconsax/linear/custom-nesting.svg": 512574,
	"core/ui/iconsax/linear/custom-notification-pin.svg": 687462,
	"core/ui/iconsax/linear/custom-numbered-list.svg": 137001,
	"core/ui/iconsax/linear/custom-palette.svg": 154502,
	"core/ui/iconsax/linear/custom-paperclip.svg": 332211,
	"core/ui/iconsax/linear/custom-pause.svg": 854250,
	"core/ui/iconsax/linear/custom-pin.svg": 659325,
	"core/ui/iconsax/linear/custom-public-page.svg": 704671,
	"core/ui/iconsax/linear/custom-puzzle-piece.svg": 215220,
	"core/ui/iconsax/linear/custom-question.svg": 4377,
	"core/ui/iconsax/linear/custom-quote.svg": 252170,
	"core/ui/iconsax/linear/custom-reply.svg": 600196,
	"core/ui/iconsax/linear/custom-rocket.svg": 905098,
	"core/ui/iconsax/linear/custom-save.svg": 726469,
	"core/ui/iconsax/linear/custom-share.svg": 54647,
	"core/ui/iconsax/linear/custom-sparkles.svg": 805936,
	"core/ui/iconsax/linear/custom-stars.svg": 168764,
	"core/ui/iconsax/linear/custom-stepper-shape.svg": 538160,
	"core/ui/iconsax/linear/custom-strikethrough.svg": 255194,
	"core/ui/iconsax/linear/custom-subtasks.svg": 79513,
	"core/ui/iconsax/linear/custom-target.svg": 965476,
	"core/ui/iconsax/linear/custom-text-subscript.svg": 834958,
	"core/ui/iconsax/linear/custom-text-superscript.svg": 114120,
	"core/ui/iconsax/linear/custom-transparent.svg": 392,
	"core/ui/iconsax/linear/custom-unpublished.svg": 741360,
	"core/ui/iconsax/linear/custom-upload.svg": 702890,
	"core/ui/iconsax/linear/custom-user-add.svg": 565008,
	"core/ui/iconsax/linear/custom-user-minus.svg": 989111,
	"core/ui/iconsax/linear/custom-video-check.svg": 186142,
	"core/ui/iconsax/linear/custom-video-file.svg": 22162,
	"core/ui/iconsax/linear/custom-widget-alt.svg": 277675,
	"core/ui/iconsax/linear/custom-x.svg": 934702,
	"core/ui/iconsax/linear/danger.svg": 767090,
	"core/ui/iconsax/linear/diamonds.svg": 515684,
	"core/ui/iconsax/linear/direct-inbox.svg": 617177,
	"core/ui/iconsax/linear/direct-normal.svg": 377577,
	"core/ui/iconsax/linear/direct-send.svg": 234946,
	"core/ui/iconsax/linear/discover.svg": 769547,
	"core/ui/iconsax/linear/dislike.svg": 609158,
	"core/ui/iconsax/linear/document-1.svg": 564240,
	"core/ui/iconsax/linear/document-text.svg": 856829,
	"core/ui/iconsax/linear/edit-2.svg": 943728,
	"core/ui/iconsax/linear/edit.svg": 762952,
	"core/ui/iconsax/linear/element-3-thick.svg": 453746,
	"core/ui/iconsax/linear/element-3.svg": 584923,
	"core/ui/iconsax/linear/element-plus.svg": 143710,
	"core/ui/iconsax/linear/export-2.svg": 870070,
	"core/ui/iconsax/linear/export.svg": 165678,
	"core/ui/iconsax/linear/eye-slash.svg": 430840,
	"core/ui/iconsax/linear/eye.svg": 507351,
	"core/ui/iconsax/linear/filter.svg": 860641,
	"core/ui/iconsax/linear/flag.svg": 843066,
	"core/ui/iconsax/linear/flash-circle.svg": 798001,
	"core/ui/iconsax/linear/flash.svg": 62329,
	"core/ui/iconsax/linear/folder-2.svg": 834791,
	"core/ui/iconsax/linear/folder.svg": 150421,
	"core/ui/iconsax/linear/gallery.svg": 376767,
	"core/ui/iconsax/linear/gift.svg": 516621,
	"core/ui/iconsax/linear/global.svg": 229199,
	"core/ui/iconsax/linear/gps.svg": 55062,
	"core/ui/iconsax/linear/graph.svg": 873810,
	"core/ui/iconsax/linear/grid-8.svg": 608187,
	"core/ui/iconsax/linear/hashtag-1.svg": 215970,
	"core/ui/iconsax/linear/headphone.svg": 685097,
	"core/ui/iconsax/linear/heart.svg": 542718,
	"core/ui/iconsax/linear/home.svg": 814398,
	"core/ui/iconsax/linear/lamp-on.svg": 867682,
	"core/ui/iconsax/linear/layer.svg": 87389,
	"core/ui/iconsax/linear/lifebuoy.svg": 147347,
	"core/ui/iconsax/linear/like.svg": 481854,
	"core/ui/iconsax/linear/link.svg": 832725,
	"core/ui/iconsax/linear/location.svg": 51899,
	"core/ui/iconsax/linear/lock-1.svg": 377230,
	"core/ui/iconsax/linear/login.svg": 833560,
	"core/ui/iconsax/linear/logout.svg": 265578,
	"core/ui/iconsax/linear/magicpen.svg": 374150,
	"core/ui/iconsax/linear/map-1.svg": 459726,
	"core/ui/iconsax/linear/medal-star.svg": 175576,
	"core/ui/iconsax/linear/menu.svg": 908511,
	"core/ui/iconsax/linear/message-text.svg": 437910,
	"core/ui/iconsax/linear/message.svg": 479734,
	"core/ui/iconsax/linear/messages-2.svg": 708981,
	"core/ui/iconsax/linear/messages-3.svg": 184490,
	"core/ui/iconsax/linear/microphone-2.svg": 884884,
	"core/ui/iconsax/linear/minus.svg": 860644,
	"core/ui/iconsax/linear/money.svg": 158523,
	"core/ui/iconsax/linear/moon.svg": 285946,
	"core/ui/iconsax/linear/more.svg": 341045,
	"core/ui/iconsax/linear/music.svg": 889757,
	"core/ui/iconsax/linear/notification.svg": 641337,
	"core/ui/iconsax/linear/numberedList.svg": 644734,
	"core/ui/iconsax/linear/path-2.svg": 625811,
	"core/ui/iconsax/linear/pause.svg": 491939,
	"core/ui/iconsax/linear/people.svg": 793929,
	"core/ui/iconsax/linear/play-circle.svg": 628926,
	"core/ui/iconsax/linear/play.svg": 454977,
	"core/ui/iconsax/linear/profile-2user.svg": 47471,
	"core/ui/iconsax/linear/profile-circle.svg": 356677,
	"core/ui/iconsax/linear/receipt-item.svg": 153063,
	"core/ui/iconsax/linear/record-circle.svg": 663197,
	"core/ui/iconsax/linear/refresh-2.svg": 766375,
	"core/ui/iconsax/linear/repeat.svg": 600794,
	"core/ui/iconsax/linear/rotate-right.svg": 501520,
	"core/ui/iconsax/linear/scan-barcode.svg": 367161,
	"core/ui/iconsax/linear/search-normal-1.svg": 217448,
	"core/ui/iconsax/linear/send-2.svg": 717707,
	"core/ui/iconsax/linear/setting-2.svg": 946107,
	"core/ui/iconsax/linear/setting-tools.svg": 289293,
	"core/ui/iconsax/linear/share.svg": 92256,
	"core/ui/iconsax/linear/shield.svg": 135700,
	"core/ui/iconsax/linear/shop.svg": 823184,
	"core/ui/iconsax/linear/sms.svg": 580726,
	"core/ui/iconsax/linear/sort.svg": 739830,
	"core/ui/iconsax/linear/star-1.svg": 917855,
	"core/ui/iconsax/linear/stop.svg": 446925,
	"core/ui/iconsax/linear/story.svg": 934610,
	"core/ui/iconsax/linear/sun-1.svg": 72758,
	"core/ui/iconsax/linear/tag.svg": 804962,
	"core/ui/iconsax/linear/teacher.svg": 667423,
	"core/ui/iconsax/linear/text-bold.svg": 922769,
	"core/ui/iconsax/linear/text-italic.svg": 607842,
	"core/ui/iconsax/linear/text-link.svg": 820146,
	"core/ui/iconsax/linear/text-strikethrough.svg": 439896,
	"core/ui/iconsax/linear/text-underline.svg": 586494,
	"core/ui/iconsax/linear/text.svg": 659395,
	"core/ui/iconsax/linear/textalign-center.svg": 458221,
	"core/ui/iconsax/linear/textalign-justifycenter.svg": 191111,
	"core/ui/iconsax/linear/textalign-left.svg": 377725,
	"core/ui/iconsax/linear/textalign-right.svg": 141290,
	"core/ui/iconsax/linear/tick-circle.svg": 316140,
	"core/ui/iconsax/linear/ticket-star.svg": 514986,
	"core/ui/iconsax/linear/timer-1.svg": 894084,
	"core/ui/iconsax/linear/trash.svg": 663894,
	"core/ui/iconsax/linear/unlock.svg": 61144,
	"core/ui/iconsax/linear/user-square.svg": 389270,
	"core/ui/iconsax/linear/user.svg": 787390,
	"core/ui/iconsax/linear/verify.svg": 744901,
	"core/ui/iconsax/linear/video-square.svg": 936315,
	"core/ui/iconsax/linear/video.svg": 516244,
	"core/ui/iconsax/linear/videoPlayIcon.svg": 383248,
	"core/ui/iconsax/linear/volume-high.svg": 494097,
	"core/ui/iconsax/linear/wallet.svg": 255721
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 824224;